import { catchError, from, of, mergeMap, switchMap } from 'rxjs';
import { ofType } from 'redux-observable';
import setUtmParameters$ from '../apis/setUtmParameters';
import utmParametersSlice from './slices';

const actions = utmParametersSlice.actions;

export default (action$) =>
  action$.pipe(
    ofType(actions.fetch.type),
    switchMap(() =>
      setUtmParameters$.pipe(
        switchMap((response) => from(response.json()).pipe(mergeMap((data) => of(actions.apply(data))))),
        catchError((err) => of(actions.handleError(err)))
      )
    )
  );
